"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkStore = void 0;
const mobx_1 = require("mobx");
const workAPI = __importStar(require("@App/api/routes/work"));
const navigation_1 = __importDefault(require("@App/navigation"));
const work_registration_forms_1 = require("@Const/work-registration-forms");
const error_messages_1 = require("@Const/error-messages");
const removers_1 = require("@App/helpers/work-entities/removers");
const publisher_side_bar_state_1 = require("@App/enum/publisher-side-bar-state");
const is_overclaim_allowed_1 = require("@App/helpers/is-overclaim-allowed");
class WorkStore {
    constructor(rootStore) {
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_worksHistoryRightsHolderPaginationInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_wizardStepIsValid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_createdWorkId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_workDraftLocal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_workById", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_redirectingToClaimingTool", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "_overclaimWarningOpen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "setOverclaimWarningOpen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (isOpen) => {
                this._overclaimWarningOpen = isOpen;
            }
        });
        Object.defineProperty(this, "onNextValidateOverclaim", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (this.isWorkDraftOverclaim() && this.isOverclaimAllowed) {
                    this.setOverclaimWarningOpen(true);
                    return false;
                }
                return true;
            }
        });
        Object.defineProperty(this, "setFoundOriginalPublisherToDraft", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (publisher) => {
                const workDraftFromLocal = this._workDraftLocal;
                if (!workDraftFromLocal) {
                    return;
                }
                const originalPublishers = workDraftFromLocal.originalPublishers;
                const lastOPId = originalPublishers.length
                    ? Number(originalPublishers[originalPublishers.length - 1].localId)
                    : 0;
                const newOriginalPublisher = {
                    localId: lastOPId + 1,
                    ipId: publisher.ipId,
                    amend: true,
                    publisherName: publisher.publisherName,
                    ipiNumber: publisher.ipiNumber ? publisher.ipiNumber : null,
                    hfaPublisherNumber: publisher.hfaPublisherNumber,
                    publisherShare: 0,
                    lastUpdated: publisher.lastUpdated,
                    administratorPublishers: [],
                    writers: [], // HARD CODE
                };
                const updatedPublisherDraft = Object.assign(Object.assign({}, workDraftFromLocal), { originalPublishers: [...originalPublishers, newOriginalPublisher] });
                this.setWorkDraftToLocal(updatedPublisherDraft);
                this.rootStore.popupStore.setPublisherSidebarState(publisher_side_bar_state_1.PublisherSideBarState.empty);
            }
        });
        Object.defineProperty(this, "setFoundAdministratorPublisher", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (publisher, currentOP) => {
                const workDraftFromLocal = this._workDraftLocal;
                if (!workDraftFromLocal) {
                    return;
                }
                const originalPublishers = workDraftFromLocal.originalPublishers;
                const currentOPid = currentOP.localId;
                const administratorPublishers = currentOP.administratorPublishers;
                const lastAPid = administratorPublishers.length
                    ? Number(administratorPublishers[administratorPublishers.length - 1].localId)
                    : 0;
                const indexOfOP = originalPublishers.map((op) => op.localId).indexOf(currentOPid);
                const newAdministratorPublisher = {
                    localId: lastAPid + 1,
                    publisherName: publisher.publisherName,
                    ipId: publisher.ipId,
                    amend: true,
                    ipiNumber: publisher.ipiNumber || null,
                    lastUpdated: publisher.lastUpdated,
                    hfaPublisherNumber: publisher.hfaPublisherNumber,
                    publisherShare: 0,
                };
                const updatedCurrentOP = Object.assign(Object.assign({}, currentOP), { publisherShare: 0, administratorPublishers: [...currentOP.administratorPublishers, newAdministratorPublisher] });
                const updatedOPArray = (0, removers_1.setItemToArrayByIndex)(originalPublishers, +indexOfOP, updatedCurrentOP);
                const updatedWorkDraft = Object.assign(Object.assign({}, workDraftFromLocal), { originalPublishers: updatedOPArray });
                this.setWorkDraftToLocal(updatedWorkDraft);
                this.rootStore.popupStore.setPublisherSidebarState(publisher_side_bar_state_1.PublisherSideBarState.empty);
            }
        });
        Object.defineProperty(this, "setRedirectTrigger", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (workAction, response) => {
                var _a, _b, _c, _d, _e;
                if (response.message) {
                    this.rootStore.popupStore.setAlertData(response.message, true);
                    return;
                }
                switch (workAction) {
                    case 0 /* WorkAction.draftCreated */:
                        this.rootStore.popupStore.setAlertData(`${response.title} was added to drafts`, false);
                        this.setWorkDraftToLocal(work_registration_forms_1.CLEAR_WORK_DRAFT);
                        (_a = this.rootStore.router) === null || _a === void 0 ? void 0 : _a.navigate(navigation_1.default.rightholder.registrationDrafts.root(this.rootStore.rightsholderStore.currentRightsholderId));
                        break;
                    case 1 /* WorkAction.workCreated */:
                        this.rootStore.popupStore.setAlertData(`${response.title} was submitted successfully!`, false);
                        (_b = this.rootStore.router) === null || _b === void 0 ? void 0 : _b.navigate(navigation_1.default.rightholder.createWork.form.submission(this.rootStore.rightsholderStore.currentRightsholderId));
                        break;
                    case 2 /* WorkAction.draftUpdated */:
                        this.rootStore.popupStore.setAlertData(`${response.title} draft has been updated`, false);
                        this.setWorkDraftToLocal(work_registration_forms_1.CLEAR_WORK_DRAFT);
                        (_c = this.rootStore.router) === null || _c === void 0 ? void 0 : _c.navigate(navigation_1.default.rightholder.registrationDrafts.root(this.rootStore.rightsholderStore.currentRightsholderId));
                        break;
                    case 3 /* WorkAction.editWorkCreated */:
                        this.rootStore.popupStore.setAlertData(`${response.title} was submitted successfully!`, false);
                        (_d = this.rootStore.router) === null || _d === void 0 ? void 0 : _d.navigate(navigation_1.default.rightholder.catalog.workEdit.submission(this.rootStore.rightsholderStore.currentRightsholderId, 'work', response.id));
                        break;
                    case 4 /* WorkAction.editDraftCreated */:
                        this.rootStore.popupStore.setAlertData(`${response.title} was submitted successfully!`, false);
                        (_e = this.rootStore.router) === null || _e === void 0 ? void 0 : _e.navigate(navigation_1.default.rightholder.catalog.workEdit.submission(this.rootStore.rightsholderStore.currentRightsholderId, 'draft', response.id));
                        break;
                }
            }
        });
        (0, mobx_1.makeObservable)(this, {
            _worksHistoryRightsHolderPaginationInfo: mobx_1.observable,
            _wizardStepIsValid: mobx_1.observable,
            _createdWorkId: mobx_1.observable,
            _workDraftLocal: mobx_1.observable,
            _workById: mobx_1.observable,
            _overclaimWarningOpen: mobx_1.observable,
            isOverclaimAllowed: mobx_1.computed,
            sharesClaimedInWizard: mobx_1.computed,
            createWriter: mobx_1.action,
            cleanPropertiesAndReturn: mobx_1.action,
            setWizardStepValidation: mobx_1.action,
            setCreatedWorkId: mobx_1.action,
            setWorkDraftToLocal: mobx_1.action,
            destroyViewWork: mobx_1.action,
            destroyDraftWork: mobx_1.action,
            createWorkFromNavBar: mobx_1.action,
            setRedirectTrigger: mobx_1.action,
            setFoundOriginalPublisherToDraft: mobx_1.action,
            setOverclaimWarningOpen: mobx_1.action,
        });
        this.rootStore = rootStore;
    }
    getWorkById(id, typeGetting) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield workAPI.getWorkById(id, typeGetting, this.rootStore.rightsholderStore.currentRightsholderId);
                if (!response) {
                    return;
                }
                const workWithLocalId = WorkStore.mapResponseToWorkObject(response.data);
                (0, mobx_1.runInAction)(() => (this._workById = workWithLocalId));
            }
            catch (e) {
                this.rootStore.popupStore.setAlertFromError(e);
            }
        });
    }
    createWriter(writer) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield workAPI.createWriter(writer);
                return response.data;
            }
            catch (e) {
                this.rootStore.popupStore.setAlertFromError(e);
                throw e;
            }
        });
    }
    cleanPropertiesAndReturn(data) {
        data.recordings = data.recordings.filter((aRecording) => !('amend' in aRecording) || aRecording.amend === true);
        data.alternativeTitles = data.alternativeTitles.filter((anAltTitle) => !('amend' in anAltTitle) || anAltTitle.amend === true);
        data.originalPublishers = data.originalPublishers.filter((aPublisher) => !('amend' in aPublisher) || aPublisher.amend === true);
        return data;
    }
    createWork(data_1, rightsHolderId_1) {
        return __awaiter(this, arguments, void 0, function* (data, rightsHolderId, isDraft = false) {
            try {
                if (!isDraft) {
                    data = this.cleanPropertiesAndReturn(data);
                }
                const response = yield workAPI.postWork(data, rightsHolderId);
                return response.data;
            }
            catch (e) {
                this.rootStore.popupStore.setAlertFromError(e);
            }
        });
    }
    deleteDraftRightsHolder(draftId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield workAPI.deleteDraftRightsHolder(draftId);
            }
            catch (e) {
                this.rootStore.popupStore.setAlertFromError(e);
            }
        });
    }
    deleteAllDraftsRightsHolder(rightsHolderId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield workAPI.deleteAllDraftsRightsHolder(rightsHolderId);
            }
            catch (e) {
                this.rootStore.popupStore.setAlertFromError(e);
            }
        });
    }
    setWizardStepValidation(isValid) {
        this._wizardStepIsValid = isValid;
    }
    setCreatedWorkId(workId) {
        this._createdWorkId = workId;
    }
    setWorkDraftToLocal(data) {
        this._workDraftLocal = data;
    }
    get workById() {
        return this._workById;
    }
    get wizardStepIsValid() {
        return this._wizardStepIsValid;
    }
    get createdWorkId() {
        return this._createdWorkId;
    }
    get workDraftLocal() {
        return this._workDraftLocal;
    }
    get overclaimWarningOpen() {
        return this._overclaimWarningOpen;
    }
    isWorkDraftOverclaim() {
        return this.sharesClaimedInWizard >= 100.06;
    }
    get sharesClaimedInWizard() {
        var _a, _b, _c;
        return ((_c = (_a = this.workDraftLocal) === null || _a === void 0 ? void 0 : _a.originalPublishers.map((op) => { var _a; return (_a = op.publisherShare) !== null && _a !== void 0 ? _a : 0; }).concat((_b = this.workDraftLocal) === null || _b === void 0 ? void 0 : _b.originalPublishers.flatMap((op) => op.administratorPublishers.map((ap) => { var _a; return (_a = ap.publisherShare) !== null && _a !== void 0 ? _a : 0; }))).reduce((partialSum, a) => partialSum + a, 0)) !== null && _c !== void 0 ? _c : 0);
    }
    get isOverclaimAllowed() {
        return (0, is_overclaim_allowed_1.isOverclaimAllowed)(this._workDraftLocal);
    }
    destroyViewWork() {
        if (!this.redirectingToClaimingTool) {
            this._workById = undefined;
        }
        this.setRedirectingToClaimingTool(false);
    }
    destroyDraftWork() {
        this._workDraftLocal = undefined;
    }
    static mapResponseToWorkObject(response) {
        return Object.assign(Object.assign({}, response), { alternativeTitles: response.alternativeTitles
                ? response.alternativeTitles.map((data, indexAT) => (Object.assign(Object.assign({}, data), { localId: indexAT + 1 })))
                : [], originalPublishers: response.originalPublishers
                ? response.originalPublishers.map((op, indexOP) => (Object.assign(Object.assign({}, op), { localId: indexOP + 1, administratorPublishers: op.administratorPublishers
                        ? op.administratorPublishers.map((ap, indexAP) => (Object.assign(Object.assign({}, ap), { localId: indexAP + 1 })))
                        : [], writers: op.writers
                        ? op.writers.map((writer, indexWR) => (Object.assign(Object.assign({}, writer), { localId: indexWR + 1 })))
                        : [] })))
                : [], writers: response.writers
                ? response.writers.map((writer, indexWR) => (Object.assign(Object.assign({}, writer), { localId: indexWR + 1 })))
                : [], recordings: response.recordings
                ? response.recordings.map((recording, indexRES) => (Object.assign(Object.assign({}, recording), { localId: indexRES + 1 })))
                : [] });
    }
    createWorkFromNavBar(data_1, rhId_1) {
        return __awaiter(this, arguments, void 0, function* (data, rhId, isDraft = false, isSavingDraft = false) {
            try {
                const workDraftFromLocal = this.workDraftLocal;
                if (!workDraftFromLocal) {
                    return;
                }
                const response = yield this.createWork(data, rhId, isDraft);
                if (isSavingDraft) {
                    this.setRedirectTrigger(0 /* WorkAction.draftCreated */, response);
                }
                else if (workDraftFromLocal.id && workDraftFromLocal.isComplete) {
                    this.setRedirectTrigger(3 /* WorkAction.editWorkCreated */, response); // Edit work to work
                }
                else if (workDraftFromLocal.id) {
                    this.setRedirectTrigger(4 /* WorkAction.editDraftCreated */, response); // Edit draft to work
                }
                else {
                    // Move to submission step
                    this.setCreatedWorkId(response.id);
                    this.setWorkDraftToLocal(response);
                    this.setRedirectTrigger(1 /* WorkAction.workCreated */, response); // Move to submission step
                }
            }
            catch (ignore) {
                this.rootStore.popupStore.setAlertData(error_messages_1.CREATE_WORK_ERROR_MESSAGE, true);
            }
        });
    }
    get redirectingToClaimingTool() {
        return this._redirectingToClaimingTool;
    }
    setRedirectingToClaimingTool(value) {
        this._redirectingToClaimingTool = value;
    }
}
exports.WorkStore = WorkStore;
